<template>
  <TButtonGroup>
    <TGroupButton
      data="italic"
      tooltip="Italic"
      small
      toggle
      :active="isItalicActive"
      :inverse="inverse"
      @button-clicked="toggleItalic"
    >
      <font-awesome-icon :icon="['fas', 'italic']" />
    </TGroupButton>
  </TButtonGroup>
</template>

<script setup lang="ts">
import { expandSelectionToWord, getActiveMarks } from "../_internal/cutomExtensions";
import { TButtonGroup, TGroupButton } from "@topol/twig-ui";
import { Editor } from "@tiptap/core";
import { computed } from "vue";

const props = defineProps<{
  editor: Editor;
  inverse?: boolean;
}>();

const isItalicActive = computed(() => {
  if (!props.editor) return false;

  // Check stored marks first (for empty paragraphs)
  const marks = getActiveMarks(props.editor);
  const hasItalicMark = marks.some((mark) => mark.type.name === "italic");
  if (hasItalicMark) return true;

  // Fallback to editor.isActive
  return props.editor.isActive("italic");
});

function toggleItalic() {
  if (!props.editor) return;
  expandSelectionToWord(props.editor);
  props.editor.chain().focus().toggleItalic().run();
}
</script>
